var featues = {};
export function registerFeature(name, feature) {
    featues[name] = feature;
}
export function getFeature(name) {
    return featues[name];
}
